import React from 'react';
import './App.css';
import Header from './Header';
import BodyPart from './BodyPart';




function App() {
  return (

    <div className="instagram">
    <Header/>
    <BodyPart/>
    </div>
  )
   
  
}

export default App;
